import script from "./SessionMoveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionMoveDialog.vue?vue&type=script&setup=true&lang=js"

import "./SessionMoveDialog.vue?vue&type=style&index=0&id=001f1b91&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001f1b91"]])

export default __exports__